import VideoSubmissionForm from './VideoSubmissionForm';

export default VideoSubmissionForm;
